import React from "react";
import TrackVisibility from "react-on-screen";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Md Shamimul Arefin",
  avatarImage: "/images/avatar-2.svg",
  content:
    "I am quite passionate about programming and technology. I love to write clean code and follow best practices. I am Seeking an internship or full-time job to become a reliable software engineer.",
};

const progressData = [
  {
    id: 1,
    title: "Work Areas",
    description: "Backend Development, Data Analysis",
    // percantage: 85,
    // progressColor: "#FFD15C",
  },
  {
    id: 2,
    title: "Languages & Frameworks",
    description: "Python, C/C++, Java, MySQL, Django",
    // percantage: 85,
    // progressColor: "#FFD15C",
  },
  {
    id: 3,
    title: "Tools & Others",
    description: "Git, Markdown, HTML, CSS",
    // percantage: 95,
    // progressColor: "#FF4C60",
  },
  {
    id: 4,
    title: "Have Knowledge of",
    description: "Data Structures and Algorithms, Problem Solving, Frontend(Basic ReactJs)",
    // percantage: 70,
    // progressColor: "#6C6CE5",
  },
];

const counterData = [
  {
    id: 1,
    title: "Projects completed",
    count: 5,
    icon: "icon-fire",
  },
  {
    id: 2,
    title: "Problem Solved",
    count: 500,
    icon: "icon-puzzle",
  },
  {
    id: 3,
    title: "Cup of coffee",
    count: 250,
    icon: "icon-cup",
  },
  {
    id: 4,
    title: "Tutorials & Blogs",
    count: 300,
    icon: "icon-notebook",
  },
];

function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <p>I solve problems as forxample on various online judge. Click To know more about{" "}
                    <a className="colorpink pointer" href="https://www.stopstalk.com/user/profile/forxample"
                    target="_blank" rel="noreferrer">forxample</a>{" "}🧡
                  </p>
                  <div className="mt-3">
                    <a href="https://docs.google.com/document/d/1PsjIkXlZlzypY6eRLGGAk5MoikigyIiKbMFdKY7ykdk/edit?usp=sharing" target="_blank" rel="noreferrer" className="btn btn-default">
                      Get Resume
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
